import { z } from "zod";

export const DeploymentCashRegisterItemSchema = z.object({
  Id: z.string(),
  Name: z.string(),
  Items: z
    .object({
      Id: z.string(),
      Name: z.string(),
    })
    .array()
    .optional(),
});

export type DeploymentCashRegisterItemType = z.infer<
  typeof DeploymentCashRegisterItemSchema
>;
